var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 342 227",
    enableBackground: "new 0 0 342 227",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    cx: 44,
    cy: 182.5,
    r: 38.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    cx: 44,
    cy: 182.5,
    r: 26.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    cx: 44,
    cy: 182.5,
    r: 13.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 35.8,
    y1: 171.7,
    x2: 28.8,
    y2: 161.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 20.2,
    y1: 171.1,
    x2: 32.1,
    y2: 175.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 39.4,
    y1: 194.8,
    x2: 33.4,
    y2: 206.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 46.4,
    y1: 208.8,
    x2: 44.7,
    y2: 196.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 57.6,
    y1: 182.7,
    x2: 70.3,
    y2: 183.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 67.8,
    y1: 170.8,
    x2: 56.9,
    y2: 177.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    cx: 279.3,
    cy: 182.5,
    r: 38.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    cx: 279.3,
    cy: 182.5,
    r: 26.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    cx: 279.3,
    cy: 182.5,
    r: 13.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 271.1,
    y1: 171.7,
    x2: 264.1,
    y2: 161.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 255.4,
    y1: 171.1,
    x2: 267.3,
    y2: 175.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 274.7,
    y1: 194.8,
    x2: 268.7,
    y2: 206.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 281.7,
    y1: 208.8,
    x2: 280,
    y2: 196.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 292.9,
    y1: 182.7,
    x2: 305.6,
    y2: 183.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 303.1,
    y1: 170.8,
    x2: 292.1,
    y2: 177.3
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M78.1,149.9l-10.3,6.9c-0.1,0.1-0.2,0.1-0.4,0.1 c-9.1,1.7-13-0.6-13-0.6c-4.6-2.4-8-9.2-8.9-11.1c-0.1-0.3-0.4-0.5-0.8-0.5c-5.5-0.3-12.3,1.6-13,1.8c0,0-0.1,0-0.1,0l-13.1,1.9 c-0.4,0.1-0.7-0.1-0.9-0.4h0c-0.5-0.9-0.4-2,0.4-2.7l9.3-7.8c0,0,0.1-0.1,0.1-0.1c18-10.3,38.5-7.7,38.5-7.7L78.1,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M59.9,124.5c0,0-13.1-0.8-28.9,6.7c0,0-10.9,6.5-16.3,13.4 c0,0-0.8,2.6,2.2,2.4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 141.8,
    transform: "matrix(0.8893 0.4573 -0.4573 0.8893 80.0103 -7.318)",
    fill: "#FFFFFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    width: 5.2,
    height: 39.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 178.8,
    transform: "matrix(0.8893 0.4573 -0.4573 0.8893 88.5093 2.316868e-02)",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    width: 3.3,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    points: "65.5,144.5 63,143.2 68.2,133.2 70,135.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M143.3,50.1v-4.9l-18.5-15.9c-0.7-0.6-1.7-0.7-2.4-0.2 c-4.1,2.5-17,10.9-24,20.9v5.2c0,1,0.7,1.9,1.7,2l6,1.2c0,0,3.3,1.8,1.3,2.8l-4.7,1.2c-1.6,0.4-3.1,1-4.6,1.8L73.3,78.5L60.2,89.2 c-1.8,1.5-3.4,3.2-4.7,5.2l-9.3,13.9c-1.1,1.6-1.2,3.6-0.4,5.3c0.9,1.9,2.5,4.4,5.3,6.6c0,0,11.2,4.3,14,8.3c0,0,8.2,10.9,13.2,22 L92,174.9c0,0,6.4,12.1,19,14.5c0,0,14.3,2.3,22,3h28.2c0,0,33.4-4.3,44.9-9.2l12-14l7.5-8.5l-5.4-5.6c0,0-45.1,10.9-49.5,11.1 l-14.1,0.2l-28.4-0.2c0,0-5.3-1.2-9.4-7.8l-5.1-9c0,0-4.5-34.5-3.6-43.6l14.4-29.8c0,0,1.9-3.1-0.2-6.1l17-15.1 C141,54.6,143.3,51.7,143.3,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M78.9,75.5h11.6c0.3,0,0.4,0.4,0.2,0.5 c-3,2.1-14.1,10.1-20.8,14c-2.1,1.2-4.4,2.1-6.8,2.5c-2.2,0.4-4.9,0.8-6.7,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M119.9,50c0,0,3.5,2.9,6.9,3.9 c0.4,0.1,0.5,0.7,0.1,0.9l-15.1,8.3c-0.3,0.1-0.2,0.5,0,0.6l12.2,6.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M102.6,62.5l7.8,4.7c0,0,1.9,1.5,0.3,4.2 c-0.2,0.3-0.4,0.5-0.7,0.7c-3.4,2.3-27.6,18.8-34.4,28.2c0,0-3.5,3.9-4.8,6.5c-0.3,0.6-0.3,1.4,0,2l9.8,19.3c0,0,1.4,2.9-0.7,3.4 l-15.1-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M115.1,65.3c0,0,0,0,0.1,0.1 c1.8,1.6,1.9,4.5,0.2,6.2l-15,15.4c-0.1,0.1-0.1,0.2-0.2,0.2L88,101.7c-0.4,0.5-0.7,1-0.9,1.6c-0.4,1.3-0.8,3.8-0.1,6.2l7.4,24.3 c0.2,0.7,0.3,1.5,0.1,2.3c-0.3,1.1-0.8,2.8-2,4.6c-1.5,2.4-3.9,4-6.7,4.5c-3.8,0.7-9.3,1.7-9.3,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    x1: 45.8,
    y1: 111.5,
    x2: 70.6,
    y2: 107.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M74.6,101.4l-18,3c-2.5,0.4-4.9,1.8-6.4,3.8 c-0.6,0.8-1.2,1.7-1.7,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M108.8,78.4h-4.4l-22.2,22.5 c0,0-0.1,0.1-0.2,0.2c-2.2,2.8-3,6.4-2.4,9.9c0.6,3.5,1.6,8.4,2.7,11.1c0,0,3.3,9.6,12.3,14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M94.1,136.1c0,0-5.9,2-11.7,2c-2.1,0-4.2-0.6-6-1.7 c-2.4-1.4-6.1-3.3-8-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M90.4,143.1c0,0,11.3-0.8,23.4,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M90.4,143.1l14.9,21.4c2.1,3,5.9,5.4,8.5,6c0.3,0.1,0.6,0.2,0.9,0.2 c0,0,42.6-1,60.5-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M82.7,145.7c0,0,1.8,9.3,6.9,16.8c0,0,5,10.1,20.1,18.1 c5.6,3,11.7,4.8,18,5.6c7.4,0.9,18.9,1.9,29.6,0.8c0,0,40.1-5.6,55-11.4"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    cx: 137.6,
    cy: 49.1,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    cx: 137.6,
    cy: 49.1,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M126.9,18.7l0-3.5c0,0,3.9-9.9,13.2-10.8c1.6-0.2,3.3,0.8,3.7,2.4 c0,0.1,0.1,0.3,0.1,0.5v7.4c0,1.6-0.3,3.2-0.9,4.6c0,0,0,0,0,0c-0.7,1.6-2.3,2.1-4.1,2.1c-0.6,0-1.1-0.1-1.3-0.5 c0,0-2.6-1.3-3.9-1.3c0,0-3.3,0.5-5.7,0.4C127.4,19.9,126.9,19.3,126.9,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#231F20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M130.2,20.8L129.5,39c0,0-0.8,3.3-2.6,3.5 c0,0-0.5,0.1-1.3,0.2c-3,0.3-3.8-4.3-0.9-4.9c0.4-0.1,0.8-0.1,1.3-0.1c0,0,0,0,0,0l0.8-18c0-0.1,0.1-0.2,0.2-0.1l2.5,0.4 C129.9,20,130.2,20.4,130.2,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M98.7,50.6c0,0,16.1-10,24.2-11.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M99.3,56.9c0,0,12.6-5.7,20.7-6.9 c0,0,0.8-4.1,4.3-4.8c0,0,3.5-1.6,3.9-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M288.1,87.4c0,0-1.3-7.5-5.2-8.8L228.6,82c0,0-21.7,4.3-29.7,4.5 h-28.5c0,0-5.9,2.9-7.9,10.5c0,0-0.6,5,0,9.7c0,0,1.1,2.9,0.4,5.9c0,0-1,2.6,0,4.1l9.8,14.7c0,0,2.3,4.3-0.3,8.7l-13,22.9h-1.5v3.4 "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 205.1,
    y1: 116.1,
    x2: 163.1,
    y2: 110.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M163.1,106.8c0,0,31.1-3.6,49.4-9.8c0,0,14.4-5.1,17.9-15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M159.4,162.9h6.4l12.5-21.4c0,0,0-0.1,0.1-0.3 c1.9-6.2-0.1-12.9-5.1-17l-10.9-9"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 171,
    y1: 166.2,
    x2: 184,
    y2: 149.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M184,149.9c0,0-1-7.3-0.8-9.3l25.8-29c0,0,9.7-9.1,25.1-13.4 c0,0,20.3-6.1,54.5-10.1c0,0,16.6,1.7,22,3.4c0,0-0.1,7-5.9,15.6l-6.3,7.2l-55.8,27.4c0,0-6.8,4-13.7,4.6L184,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M297.3,115.1c0,0-80,7.5-112.9,34.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M309.8,92.8l-23,4.2c0,0-41.5,4-59.9,13l-42.5,29.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M306.8,103.8h-6c-3.7,0-7.3-1-10.3-3.1c-1.4-1-2.7-2.2-3.7-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M213.7,174.2l13.5-1.4l22.5-11.4l49-7.5l12,0.9l1.1,10.7 l-11.2,4.6c0,0,2.2,5.3-0.5,8.3c0,0-2.7,5.1-17,7.8c0,0-17.6,2.4-28.2,3.3c-3.8,0.3-7.6,0.2-11.3-0.3c-7.8-1.1-23.3-3.6-35.6-8.2 L213.7,174.2z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    points: "209.4,179.1 251.1,179.1 252.1,179.1 300.5,170  298.6,153.9  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 249,
    y1: 161.7,
    x2: 251.1,
    y2: 179.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 232.4,
    y1: 179.1,
    x2: 230.4,
    y2: 171.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 223,
    y1: 158.1,
    x2: 225.4,
    y2: 146.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 242,
    y1: 165.2,
    x2: 242,
    y2: 142.3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    points: "275.9,157.3 269.4,158.3 258.6,134.1 264.2,131.4  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    cx: 253.4,
    cy: 153.9,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    cx: 294.7,
    cy: 122.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M276.4,125.4c0,0,9.9,0.3,12.8,1c0,0,8,2.7,19.7,16 c0,0,12.1,14.6,21.1,20.1c0.8,0.5,1.6,0.7,2.5,0.7l0,0c1.6,0,2.2-2.2,0.7-2.9c0,0,0,0-0.1,0c0,0-11.7-8-16.9-15.8l-17.9-29.8 L276.4,125.4z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    points: "307.9,130.4 307.9,122 302.6,122  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 259.8,
    y1: 136.8,
    x2: 265.7,
    y2: 134
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 261.1,
    y1: 139.7,
    x2: 267.1,
    y2: 136.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 262.4,
    y1: 142.3,
    x2: 268.3,
    y2: 139.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 263.6,
    y1: 144.9,
    x2: 269.5,
    y2: 142
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 264.9,
    y1: 147.7,
    x2: 270.9,
    y2: 144.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 266,
    y1: 150.8,
    x2: 272,
    y2: 148
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 267.2,
    y1: 153.3,
    x2: 273.2,
    y2: 150.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    x1: 268.5,
    y1: 156,
    x2: 274.4,
    y2: 153.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScooter);
export default __webpack_public_path__ + "static/media/scooter.1443dbd29c676a89fd62c3d9111af1c6.svg";
export { ForwardRef as ReactComponent };